// src/state/slices/categorySlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchCategoriesAndSubcategories } from "../../graphql/api/categoryService";
import { Subcategory } from "../../interfaces/product";
import { Category } from "../../interfaces/home_entity";

// Thunk to load categories and subcategories
export const loadCategories = createAsyncThunk(
  "categories/load",
  async () => {
    const data = await fetchCategoriesAndSubcategories(); // should return { categories: Category[], subcategories: Subcategory[] }
    return data;
  }
);

// Define the slice state type
interface CategoryState {
  categories: Category[];
  subcategories: Subcategory[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: CategoryState = {
  categories: [],
  subcategories: [],
  loading: false,
  error: null,
};

// Create slice
const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadCategories.fulfilled, (state, action: PayloadAction<{ categories: Category[]; subcategories: Subcategory[] }>) => {
        state.loading = false;
        state.categories = action.payload.categories;
        state.subcategories = action.payload.subcategories;
      })
      .addCase(loadCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Error loading categories";
      });
  },
});

export default categorySlice.reducer;
